import {Ref, useEffect, useRef} from 'react';

/**
 * forwardRef 를 사용한 컴포넌트에서 ref 를 재사용하기 위한 hook \
 * 참고 : https://gist.github.com/pie6k/b4717f392d773a71f67e110b42927fea
 */
export function useShareForwardedRef<T>(forwardedRef: Ref<T>) {
  // final ref that will share value with forward ref. this is the one we will attach to components
  const innerRef = useRef<T>(null);

  useEffect(() => {
    // after every render - try to share current ref value with forwarded ref
    if (!forwardedRef) {
      return;
    }
    if (typeof forwardedRef === 'function') {
      forwardedRef(innerRef.current);
      return;
    } else {
      // @ts-ignore
      // by default forwardedRef.current is readonly. Let's ignore it
      forwardedRef.current = innerRef.current;
    }
  });

  return innerRef;
}
